import { IEmailTemplateOrderConfirmation } from './order-confirmation';

export interface IEmailTemplateOrderConfirmationUpdate {
    [key: string]: IEmailTemplateOrderConfirmation;
}
